import { RegionRepository } from './repositories/regions'
import { RegionService } from './services/regions'

const regionRepository = new RegionRepository()

export const regionService = new RegionService({
    regionRepository,
})
